import { render, staticRenderFns } from "./UserReference.vue?vue&type=template&id=3405eb16&scoped=true"
import script from "./UserReference.vue?vue&type=script&lang=ts"
export * from "./UserReference.vue?vue&type=script&lang=ts"
import style0 from "./UserReference.vue?vue&type=style&index=0&id=3405eb16&prod&lang=scss&scoped=true"
import style1 from "./UserReference.vue?vue&type=style&index=1&id=3405eb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405eb16",
  null
  
)

export default component.exports